import React, { FC } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";
import { InputNumber } from "primereact/inputnumber";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { DialIndicatorMinMaxValueEditorProps, ValueType } from "./DialIndicatorTypes";

export const valueTypeOptions = [
  { label: T("word.dataset"), value: ValueType.DATASET },
  { label: T("word.constant"), value: ValueType.CONSTANT },
];

const DialIndicatorMinMaxValueEditor: FC<DialIndicatorMinMaxValueEditorProps> = ({
  config,
  onConfigChange,
  isMinValue,
}) => {
  const getConstantValue = () => {
    if (isMinValue) {
      return (config.minValue as number) ?? 0;
    }
    return (config.maxValue as number) ?? 0;
  };

  return (
    <div className="w-full flex align-items-center gap-3 flex-wrap md:flex-nowrap">
      <div className="flex flex-column">
        <label htmlFor="usage">{isMinValue ? T("label.min-value") : T("label.max-value")}</label>
        <Dropdown
          id="usage"
          value={isMinValue ? config.minValueType : config.maxValueType}
          className="w-9rem p-inputtext-sm"
          options={valueTypeOptions}
          onChange={e =>
            onConfigChange({ ...config, [isMinValue ? "minValueType" : "maxValueType"]: e.value })
          }
        />
      </div>
      {((isMinValue && config.minValueType === "constant") ||
        (!isMinValue && config.maxValueType === "constant")) && (
        <div className="flex flex-column">
          <label htmlFor="constant">{T("word.constant")}</label>
          <InputNumber
            id="constant"
            value={getConstantValue()}
            onValueChange={e =>
              onConfigChange({ ...config, [isMinValue ? "minValue" : "maxValue"]: e.value })
            }
            useGrouping={false}
            maxFractionDigits={2}
            className="p-inputtext-sm"
          />
        </div>
      )}
      {((isMinValue && config.minValueType === "dataset") ||
        (!isMinValue && config.maxValueType === "dataset")) && (
        <div className="w-full">
          <label htmlFor="baselineDataset">{T("label.baseline-dataset")}</label>
          <DatasetDropdown
            value={String(isMinValue ? config.minValue : config.maxValue)}
            onChange={val =>
              onConfigChange({ ...config, [isMinValue ? "minValue" : "maxValue"]: val })
            }
          />
        </div>
      )}
      <div className="flex flex-column">
        <label htmlFor="overriddenValue">{T("label.overridden-value")}</label>
        <InputText
          id="overriddenValue"
          value={isMinValue ? config.minValueOverride : config.maxValueOverride}
          onChange={e =>
            onConfigChange({
              ...config,
              [isMinValue ? "minValueOverride" : "maxValueOverride"]: e.target.value,
            })
          }
          className="p-inputtext-sm"
        />
      </div>
    </div>
  );
};

export default DialIndicatorMinMaxValueEditor;
